<template v-if="slideCount">
  <div class="component-wrapper">

    <!-- Slides -->
    <div class="slider__track" ref="track" scroll-behavior="smooth">
      <slot />
    </div>

    <!-- Arrows -->
    <div v-if="arrows" class="slider__arrows">
      <div class="left btn" ref="prev" :class="{ disable: disableLeftArrow }" @click="prev()">
        <IconChevron v-if="arrow_style == 'chevron'" :direction="'left'" />
        <IconArrow v-else :direction="'left'" />
      </div>
      <div class="right btn" ref="next" :class="{ disable: disableRightArrow }" @click="next()">
        <IconChevron v-if="arrow_style == 'chevron'" :direction="'right'" />
        <IconArrow v-else :direction="'right'" />
      </div>
    </div>

  </div>
</template>

<script>
import IconArrow from '../Icons/IconArrow'
import IconChevron from '../Icons/IconChevron'

export default {
  components: { IconArrow, IconChevron },

  props: [ 'slide_by_quarter', 'slide_by', 'arrows', 'arrow_style' ],

  data () {
    return {
      slideCount       : 0,
      scrollWidth      : 0,
      disableLeftArrow : true,
      disableRightArrow: false,
      observer         : null,
      event            : new Event('slider_arrow_click')
    }
  },

  mounted () {
    this.observer = new MutationObserver(function (mutations) {
      this.slideCount = this.$refs.track.childElementCount
      this.scrollWidth = this.$refs.track.scrollWidth / this.slideCount
      if (this.slide_by_quarter) this.scrollWidth = window.innerWidth / 4
      if (this.slide_by) this.scrollWidth = this.$refs.track.scrollWidth / (this.slideCount / this.slide_by)
    }.bind(this))
    this.observer.observe(
      this.$refs.track,
      { attributes: true, childList: true, characterData: true, subtree: true }
    )
  },
  
  beforeDestroy () {
    this.observer.disconnect()
  },

  methods: {
    prev () {
      this.disableRightArrow = false

      let current_active = this.$refs.track.querySelector('.active')

      this.disableLeftArrow = !current_active.previousElementSibling || current_active.dataset.index == 1

      if (this.disableLeftArrow == false) {
        this.$refs.track.scrollLeft = (this.$refs.track.scrollLeft - this.scrollWidth)

        if (current_active.previousElementSibling) {
          current_active.classList.remove('active')
          current_active.previousElementSibling.classList.add('active')

          this.disableLeftArrow = current_active.previousElementSibling.dataset.index == 1

          this.event.activeSlide = current_active.previousElementSibling
          this.$refs.prev.dispatchEvent(this.event)
        }
      } else {
        this.$refs.track.scrollLeft = 0
      }
    },

    next () {
      this.disableLeftArrow = false

      let current_active = this.$refs.track.querySelector('.active')

      this.disableRightArrow = current_active.dataset.index == this.slideCount || (this.$refs.track.scrollLeft + this.$refs.track.clientWidth) === this.$refs.track.scrollWidth

      if (this.disableRightArrow == false) {
        this.$refs.track.scrollLeft = (this.$refs.track.scrollLeft + this.scrollWidth)

        if (current_active.nextElementSibling) {
          current_active.classList.remove('active')
          current_active.nextElementSibling.classList.add('active')

          this.disableRightArrow = current_active.nextElementSibling.dataset.index == this.slideCount

          this.event.activeSlide = current_active.nextElementSibling
          this.$refs.next.dispatchEvent(this.event)
        }
      } else {
        this.$refs.track.scrollLeft = this.$refs.track.scrollWidth
      }
    }
  }
}
</script>
